var _style, _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 79.2 79.4",
    style: {
      enableBackground: "new 0 0 79.2 79.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#1A1A1A;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.0543,
    y1: 39.7334,
    x2: 77.0543,
    y2: 39.7334
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#902348"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E72144"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.6,2.2C18.8,2.2,2.1,19,2.1,39.7c0,20.7,16.8,37.5,37.5,37.5c20.7,0,37.5-16.8,37.5-37.5 C77.1,19,60.3,2.2,39.6,2.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.6,79.2c-21.8,0-39.5-17.7-39.5-39.5S17.8,0.2,39.6,0.2S79.1,18,79.1,39.7S61.3,79.2,39.6,79.2z M39.6,4.2 C20,4.2,4.1,20.2,4.1,39.7S20,75.2,39.6,75.2s35.5-15.9,35.5-35.5S59.1,4.2,39.6,4.2z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.8,61.9l-4-0.1l0.1-4.4c0-6.9-5.7-12.5-12.6-12.5s-12.6,5.7-12.6,12.6l0,0.3l-0.5,4l-4-0.5l0.5-3.9 c0.1-9.1,7.5-16.5,16.6-16.5c9.2,0,16.6,7.4,16.6,16.6L56.8,61.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 28.1,
    cy: 28.7,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 28.7,
    r: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.aabf464a16c9c605f2c733099d1f9157.svg";
export { ForwardRef as ReactComponent };